import type { IToastService } from './ToastService.js';

/// Småwidgets der ikke fortjener egen service: password-eye + custom-toggle-
/// switch. UI-only — toggle-switch'en kalder kun toast i skelet-iterationen
/// (it.2 binder den til real PATCH-API-kald).

export interface IUiToggleService {
  togglePasswordVisibility(btn: HTMLElement): void;
  toggleSwitch(el: HTMLElement, label: string): void;
}

export class UiToggleService implements IUiToggleService {
  constructor(private readonly toasts: IToastService) { }

  togglePasswordVisibility(btn: HTMLElement): void {
    const wrap = btn.closest('.input-wrap');
    const input = wrap?.querySelector<HTMLInputElement>('input');
    if (!input) return;

    const wasVisible = input.type === 'text';
    input.type = wasVisible ? 'password' : 'text';
    btn.innerHTML = wasVisible
      ? '<i class="ph ph-eye"></i>'
      : '<i class="ph ph-eye-slash"></i>';
  }

  toggleSwitch(el: HTMLElement, label: string): void {
    el.classList.toggle('on');
    const isOn = el.classList.contains('on');
    this.toasts.show(`${label} ${isOn ? 'aktiveret' : 'deaktiveret'}`);
  }
}
